import { Menu, MenuItem, Typography } from '@mui/material';

import { DesktopInnerProps } from './types';

export const DesktopNavInner = ({ open, subItems, anchorEl, handleClose, onSubItemClick }: DesktopInnerProps) => {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(open)} onClose={handleClose} onClick={handleClose}>
      {subItems.map(({ isExternal, path, onClick, buttonProps, isActive, text }, key) => {
        // Currently, only support one level down navigation
        const menuItemProps = isExternal
          ? {
              component: 'a',
              href: path,
              target: '_blank',
              rel: 'noopener noreferrer',
            }
          : undefined;

        const handleMenuItemOnClick = () => {
          if (buttonProps.onClick) {
            buttonProps.onClick();
          } else if (onClick) {
            onClick();
          }
          handleClose();
        };

        return (
          <MenuItem key={key} {...buttonProps} {...menuItemProps} selected={isActive} onClick={handleMenuItemOnClick}>
            <Typography component="span" className="nav-item-inner" onClick={onSubItemClick}>
              {text}
            </Typography>
          </MenuItem>
        );
      })}
    </Menu>
  );
};
